module.exports = __webpack_public_path__ + "static/img/index_banner.7d313ac.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_banner.gif
// module id = YUOG
// module chunks = 0